import { resolveKyrosApiUrl } from "./apiConfig";

const PASSWORD_RECOVERY_ENDPOINTS = Object.freeze({
  forgot: "/auth/password/forgot",
  reset: "/auth/password/reset",
});

const normalizeEmail = (value) => String(value || "").trim().toLowerCase();
const normalizeSecret = (value) => String(value || "").trim();
const extractApiMessage = (data, fallback) =>
  String(
    (data && (data.error || data.message || data.detail || data.status)) || fallback || ""
  ).trim();

async function postJson(path, payload) {
  const response = await fetch(resolveKyrosApiUrl(path), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(extractApiMessage(data, "Richiesta non riuscita."));
  }

  return data;
}

export async function requestPasswordRecoveryEmail(email) {
  const normalizedEmail = normalizeEmail(email);
  if (!normalizedEmail) {
    throw new Error("Inserisci un indirizzo email valido.");
  }

  const locale =
    typeof navigator !== "undefined" ? navigator.language || "it-IT" : "it-IT";

  return postJson(PASSWORD_RECOVERY_ENDPOINTS.forgot, {
    email: normalizedEmail,
    locale,
  });
}

export async function confirmPasswordReset({ secret, secretField = "code", password }) {
  const normalizedSecret = normalizeSecret(secret);
  const nextPassword = String(password || "");
  if (!normalizedSecret) {
    throw new Error("Il link di reset non e valido.");
  }
  if (nextPassword.length < 8) {
    throw new Error("La password deve avere almeno 8 caratteri.");
  }

  const fieldName = secretField === "token" ? "token" : "code";
  return postJson(PASSWORD_RECOVERY_ENDPOINTS.reset, {
    [fieldName]: normalizedSecret,
    password: nextPassword,
  });
}

export { PASSWORD_RECOVERY_ENDPOINTS };
